import React from 'react'
import styled from 'styled-components'
import actionsConfig from '../actions-config'
import Action from './Action'

Actions = ({labels, card, color, demo})->
	<Wrapper>
		{actionsConfig.map (action, i)->			
			<Action
				{prepareActionData(action, labels, card)...}
				key={i}
				card={card}
				color={color}
				demo={demo} 
			/>
		}
	</Wrapper>


prepareActionData = (action, labels, card)->
	update = {}
	
	if action.name is 'save' and card._id
		update.href = "/api/cards/vcf/#{card._id}"

	if action.name is 'getyourown' and card._id
		update.href = "#{action.href}?ref=#{card._id}"

	if labels?[action.name]
		update.label = labels[action.name]
	
	return {action..., update...}


Wrapper = styled.div"""
	box-sizing: border-box
	padding: 20px
"""

export default Actions